import Fade from "react-reveal/Fade";
import React from "react";

export default function WhatIDo() {
  return (
    <div className="my-6">
      <div className="rounded-lg bg-gray-800 flex flex-col lg:flex-row">
        <div className="p-8 w-full lg:w-1/2 border border-l-0 border-t-0 border-r-0 border-b-2 lg:border-b-0 lg:border-r-2 border-gray-700 border-dashed">
          <Fade up cascade>
            <div>
              <svg
                className="h-28 w-28 fill-current text-blue-500 mx-auto"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="7 7 50 50"
              >
                <path d="M 11 17 A 1 1 0 0 0 10 18 L 10 22 A 1 1 0 0 0 11 23 L 15 23 A 1 1 0 0 0 16 22 L 16 21 L 23.320312 21 A 20 20 0 0 0 12.050781 38 L 11 38 A 1 1 0 0 0 10 39 L 10 43 A 1 1 0 0 0 11 44 L 15 44 A 1 1 0 0 0 16 43 L 16 39 A 1 1 0 0 0 15 38 L 14.039062 38 A 18 18 0 0 1 30.25 21.105469 L 20.123047 39.517578 A 1 1 0 0 0 21 41 A 5.19 5.19 0 0 1 26 45.111328 L 26 48 A 1 1 0 0 0 25 49 L 25 54 A 1 1 0 0 0 26 55 L 38 55 A 1 1 0 0 0 39 54 L 39 49 A 1 1 0 0 0 38 48 L 38 45.109375 A 5.147 5.147 0 0 1 43 41 A 1 1 0 0 0 43.876953 39.517578 L 33.748047 21.103516 A 18 18 0 0 1 49.949219 38 L 49 38 A 1 1 0 0 0 48 39 L 48 43 A 1 1 0 0 0 49 44 L 53 44 A 1 1 0 0 0 54 43 L 54 39 A 1 1 0 0 0 53 38 L 51.966797 38 A 20 20 0 0 0 40.679688 21 L 48 21 L 48 22 A 1 1 0 0 0 49 23 L 53 23 A 1 1 0 0 0 54 22 L 54 18 A 1 1 0 0 0 53 17 L 49 17 A 1 1 0 0 0 48 18 L 48 19 L 16 19 L 16 18 A 1 1 0 0 0 15 17 L 11 17 z M 12 19 L 14 19 L 14 21 L 12 21 L 12 19 z M 50 19 L 52 19 L 52 21 L 50 21 L 50 19 z M 31 23.892578 L 31 35.128906 A 4 4 0 0 0 32 43 A 4 4 0 0 0 36 39 A 4 4 0 0 0 33 35.128906 L 33 23.892578 L 41.400391 39.162109 A 7.3 7.3 0 0 0 36.019531 44.800781 A 1 1 0 0 0 36 45 L 36 48 L 28 48 L 28 45 A 1 1 0 0 0 27.980469 44.800781 A 7.3 7.3 0 0 0 22.599609 39.166016 L 31 23.892578 z M 32 37 A 2 2 0 0 1 34 39 A 2 2 0 1 1 32 37 z M 12 40 L 14 40 L 14 42 L 12 42 L 12 40 z M 50 40 L 52 40 L 52 42 L 50 42 L 50 40 z M 27 50 L 37 50 L 37 53 L 27 53 L 27 50 z"></path>
              </svg>
              <div>
                <h1 className="mt-8 font-primary text-4xl font-bold text-white text-center transition duration-500 ease-in-out transform hover:scale-105 hover:text-yellow-400">
                  Developer
                </h1>
              </div>
              <h3 className="mt-4 font-secondary text-lg font-normal text-gray-400 text-center">
                I like to code things from scratch and bring ideas to life.
              </h3>

              <h3 className="mt-12 font-secondary text-lg font-medium text-blue-500 text-center">
                Languages I Know:
              </h3>
              <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
                C++,Java, JavaScript, HTML, CSS
              </p>
              <h3 className="mt-12 font-secondary text-lg font-medium text-blue-500 text-center">
                Dev Tools:
              </h3>

              <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
                React
              </p>
              <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
                MongoDB
              </p>
              <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
                Node
              </p>
              <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
                Ecclipse
              </p>

              <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
                MySQL
              </p>
              <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
                Spring
              </p>
              <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
                Git
              </p>
            </div>
          </Fade>
        </div>
        <Fade up cascade>
          <div className="p-8 w-full lg:w-1/2">
            <svg
              className="h-28 w-28 fill-current text-blue-500 mx-auto"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M 83 46.355469 A 50.057 50.057 0 0 0 33 96.355469 L 33 415.64453 A 50.057 50.057 0 0 0 83 465.64453 L 429 465.64453 A 50.057 50.057 0 0 0 479 415.64453 L 479 96.355469 A 50.057 50.057 0 0 0 429 46.355469 L 83 46.355469 z M 83 66.355469 L 429 66.355469 A 30.034 30.034 0 0 1 459 96.355469 L 459 147.51367 L 53 147.51367 L 53 96.355469 A 30.034 30.034 0 0 1 83 66.355469 z M 53 167.51367 L 459 167.51367 L 459 415.64453 A 30.034 30.034 0 0 1 429 445.64453 L 83 445.64453 A 30.034 30.034 0 0 1 53 415.64453 L 53 167.51367 z M 270.20508 215.01172 A 10 10 0 0 0 260.02344 222.53516 L 221.76758 373.03516 A 10.000308 10.000308 0 0 0 241.15039 377.96484 L 279.4082 227.46484 A 10 10 0 0 0 272.17969 215.30859 A 10 10 0 0 0 270.20508 215.01172 z M 309.42969 246.40234 A 10.000353 10.000353 0 0 0 302.66797 263.53711 L 339.5293 299.70898 L 302.66797 335.88086 A 10.000353 10.000353 0 0 0 316.67578 350.15625 L 360.8125 306.84766 A 10 10 0 0 0 360.8125 292.57031 L 316.67578 249.26172 A 10.000353 10.000353 0 0 0 309.42969 246.40234 z M 195.7832 246.4043 A 10 10 0 0 0 188.83008 249.26562 L 144.69336 292.57422 A 10 10 0 0 0 144.69336 306.85156 L 188.83008 350.16016 A 10.000353 10.000353 0 1 0 202.83789 335.88477 L 165.97656 299.71289 L 202.83789 263.54297 A 10 10 0 0 0 202.97266 249.40039 A 10 10 0 0 0 195.7832 246.4043 z"></path>
            </svg>
            <Fade up>
              <div>
                <h1 className="mt-8 font-primary text-4xl font-bold text-white text-center transition duration-500 ease-in-out transform hover:scale-105 hover:text-yellow-400">
                  Designer
                </h1>
              </div>
            </Fade>
            <h3 className="mt-4 font-secondary text-lg font-normal text-gray-400 text-center">
              I like to design beautiful things that are easy to use.
            </h3>
            <h3 className="mt-12 font-secondary text-lg font-medium text-blue-500 text-center">
              Things I Design:
            </h3>
            <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
              UI/UX, Web and Mobile Design, Static Graphic Design
            </p>
            <h3 className="mt-12 font-secondary text-lg font-medium text-blue-500 text-center">
              Design Tools:
            </h3>
            <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
              Figma
            </p>
            <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
              Adobe XD
            </p>
            <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
              Adobe Photoshop
            </p>
            <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
              Adobe Illustrator
            </p>
            <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
              Adobe Indesign
            </p>
            <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
              Canva
            </p>

            <p className="mt-2 font-secondary text-lg font-normal text-gray-400 text-center">
              Adobe Premiere Pro
            </p>
          </div>
        </Fade>
      </div>
    </div>
  );
}
